import React from 'react';

import { Button, Modal } from 'antd/lib';

import { graphql, compose, withApollo } from 'react-apollo';

import Loading from '../../common/Loading';
import _ from 'lodash';
import moment from 'moment';

import TablaMostrarDepositos from '../reportes/TablaMostrarDepositos';
import TablaReporteVentas from '../reportes/TablaMostrarReporte';

import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';
import getOrganismos from '../../../graphql/querys/organismos/getOrganismos.graphql';
import { imprimirReporteRendicion } from '../../common/impresion/ImprimirReporteRendicion';

@compose(
  graphql(getUsuario, {
    name: 'usuario',
  }),
  graphql(getOrganismos)
)
class VerReportesRendicion extends React.Component {
  state = {
    tipo_sellos: [],
    ventas_efectivo: [],
    ventas_posnet: [],
    detalle_posnet: [],
    envios: [],
    llamada: false,
    fechaInicio: '',
    fechaFin: '',
    idOrganismo: '',
    step: 0,
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.ingresos) {
      // console.log("ADASDASDSADSADASDAS");
      // console.log(this.state);
      _.map(nextProps.ingresos, ingreso => this.formarEnvios(ingreso));
    }
  }

  formarEnvios = envio => {
    //Esta funcion, recorre los detalle de una venta
    // Y actualiza el estado interno de componente, dependiendo los sellos del detalle.

    // console.log('EL ENVIO ES...');
    // console.log(envio);
    try {
      _.map(envio.detalle, detalle => {
        let nuevosTipo_sellos = this.state.envios;
        let nuevoDetalle = {
          idTipo_Sello: detalle.tipo_sello._id,
          nombre: detalle.tipo_sello.nombre,
          valor: detalle.tipo_sello.valor,
          cantidad: detalle.cantidad,
        };
        nuevosTipo_sellos.push(nuevoDetalle);

        var output = _(nuevosTipo_sellos)
          .groupBy('idTipo_Sello')
          .map((objs, key) => ({
            _id: key,
            idTipo_Sello: key,
            nombre: objs[0].nombre,
            valor: objs[0].valor,
            cantidad: _.sumBy(objs, 'cantidad'),
            subtotal: objs[0].valor * _.sumBy(objs, 'cantidad'),
          }))
          .value();

        // console.log("TENEMOS::::::::");
        // console.log({output});

        this.setState({
          envios: output,
        });
      });
    } catch (err) {
      Modal.error({
        title: 'Error en el calculo de los items de los envios',
        content:
          'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
      });
      console.log(err);
    }
  };

  imprimir = () => {
    imprimirReporteRendicion({
      detalle_efectivo: this.props.ventasEfectivo
        ? this.props.ventasEfectivo.detalles
        : [],
      detalle_posnet: this.props.ventasPosnet
        ? this.props.ventasPosnet.detalles
        : [],
      depositos: this.props.depositos,
      envios: this.props.envios,
      fechaGeneracion: moment(this.props.fechaGeneracion).format(
        'DD/MM/YYYY HH:mm'
      ),
      fechaInicio: moment(this.props.fechaInicio).format('DD/MM/YYYY'),
      fechaFin: moment(this.props.fechaFin).format('DD/MM/YYYY'),
      nombreOrganismo: this.props.nombreOrganismo,
    });
  };

  render() {
    const { data } = this.props;
    if (data.loading) {
      return <Loading />;
    }

    let fInicio = moment(this.props.fechaInicio).format('DD/MM/YYYY');
    let fFin = moment(this.props.fechaFin).format('DD/MM/YYYY');

    let montoTotalDepositos = _.sumBy(this.props.depositos, o => {
      return o.importe;
    });

    return (
      <div>
        <h1 style={{ textAlign: 'center' }}>Administración General</h1>
        <div>
          <h2 style={{ textAlign: 'center', marginTop: 40 }}>
            Reporte de Rendicion
          </h2>

          <h2 style={{ textAlign: 'center', marginTop: 40 }}>
            Organismo: {this.props.nombreOrganismo}
          </h2>

          <h3 style={{ textAlign: 'center', marginTop: 20 }}>
            Reporte para el rango de fechas de: {fInicio} - {fFin}
          </h3>

          <h5 style={{ textAlign: 'center', marginTop: 20 }}>
            Fecha de generacion:
            {moment(this.props.fechaGeneracion).format('DD/MM/YYYY')}
          </h5>

          <br />

          {/* Ventas del Periodo de Fechas */}
          <h3 style={{ textAlign: 'center', marginTop: 20 }}>
            VENDIDOS EN EFECTIVO DEL: {fInicio} AL {fFin}
          </h3>
          <TablaReporteVentas
            organismo={this.props.nombreOrganismo}
            fechaInicio={this.props.fechaInicio}
            fechaFin={this.props.fechaFin}
            data={
              this.props.ventasEfectivo
                ? this.props.ventasEfectivo.detalles
                : []
            }
            onCancelar={this.onCancelar}
          />
          <h3 style={{ textAlign: 'center', marginTop: 10 }}>
            Monto: $ {this.props.ventasEfectivo.importe}
          </h3>

          {/* Ventas del Periodo de Fechas */}
          <h3 style={{ textAlign: 'center', marginTop: 20 }}>
            VENDIDOS EN POSNET DEL: {fInicio} AL {fFin}
          </h3>
          <TablaReporteVentas
            organismo={this.props.nombreOrganismo}
            fechaInicio={this.props.fechaInicio}
            fechaFin={this.props.fechaFin}
            data={
              this.props.ventasPosnet ? this.props.ventasPosnet.detalles : []
            }
            onCancelar={this.onCancelar}
          />
          <h3 style={{ textAlign: 'center', marginTop: 10 }}>
            Monto: $ {this.props.ventasPosnet.importe}
          </h3>

          {/* Depositos del Rango de Fecha */}
          <h3 style={{ textAlign: 'center', marginTop: 20 }}>
            DEPOSITOS EFECTUADOS ENTRE LAS FECHAS: {fInicio} - {fFin}
          </h3>
          <TablaMostrarDepositos
            organismo={this.props.nombreOrganismo}
            fechaInicio={this.props.fechaInicio}
            fechaFin={this.props.fechaFin}
            data={this.props.depositos}
            onCancelar={this.onCancelar}
          />
          <h3 style={{ textAlign: 'center', marginTop: 10 }}>
            Monto: $ {montoTotalDepositos}
          </h3>
          <br />
          <br />
          <h3 style={{ textAlign: 'center', marginTop: 10 }}>
            <Button
              style={{ margin: 5 }}
              type="danger"
              onClick={() => this.props.atras()}
            >
              Atras
            </Button>
            <Button style={{ margin: 5 }} onClick={() => this.imprimir()}>
              Imprimir
            </Button>
          </h3>
        </div>
      </div>
    );
  }
}

export default withApollo(VerReportesRendicion);
